import { init, type ConfigDDJ, type Selectors } from '@makemydeal/dr-activities-ddj';
import { DIGITAL_DEAL_JACKET_SOURCE } from '@makemydeal/dr-sales-checkin-components';

import { additionalSelectors } from './additionalSelectors';

export let ddjSelectors: Selectors;

export const configureDdj = (config: ConfigDDJ = { source: DIGITAL_DEAL_JACKET_SOURCE }): Selectors => {
    const { selectors } = init(additionalSelectors, config);
    ddjSelectors = selectors;
    return selectors;
};

export const getDdjSelectors = (): Selectors => ddjSelectors;
